import { render, staticRenderFns } from "./IbDrag.vue?vue&type=template&id=997acd78&scoped=true"
import script from "./IbDrag.vue?vue&type=script&lang=js"
export * from "./IbDrag.vue?vue&type=script&lang=js"
import style0 from "./IbDrag.vue?vue&type=style&index=0&id=997acd78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997acd78",
  null
  
)

export default component.exports